import { render, staticRenderFns } from "./numpad.vue?vue&type=template&id=0edc45b7"
import script from "./numpad.vue?vue&type=script&lang=js"
export * from "./numpad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports